export default __webpack_public_path__ + "static/media/cubeDark.5e19a9cb.png";